package com.dotdrives.repository

import com.dotdrives.client.OrgClient
import com.dotdrives.model.OrgInvite
import com.dotdrives.model.OrgMember
import com.dotdrives.model.OrgSummary

interface OrgRepository {
    suspend fun openDeepLink(orgId: String): Result<Unit> =
        Result.failure(UnsupportedOperationException("Organization deep links are unavailable."))

    suspend fun myOrgs(): Result<List<OrgSummary>>

    suspend fun createOrg(name: String, kind: String): Result<OrgSummary>

    suspend fun updateOrg(orgId: String, name: String, kind: String): Result<OrgSummary>

    suspend fun members(orgId: String): Result<List<OrgMember>>

    suspend fun invite(orgId: String, email: String, role: String): Result<Unit>

    suspend fun invites(orgId: String): Result<List<OrgInvite>>
}

class SupabaseOrgRepository(
    private val client: OrgClient = OrgClient(),
) : OrgRepository {
    override suspend fun openDeepLink(orgId: String): Result<Unit> =
        runCatching { client.openDeepLink(orgId) }

    override suspend fun myOrgs(): Result<List<OrgSummary>> =
        runCatching { client.myOrgs() }

    override suspend fun createOrg(name: String, kind: String): Result<OrgSummary> =
        runCatching { client.createOrg(name, kind) }

    override suspend fun updateOrg(
        orgId: String,
        name: String,
        kind: String,
    ): Result<OrgSummary> =
        runCatching { client.updateOrg(orgId, name, kind) }

    override suspend fun members(orgId: String): Result<List<OrgMember>> =
        runCatching { client.members(orgId) }

    override suspend fun invite(orgId: String, email: String, role: String): Result<Unit> =
        runCatching { client.invite(orgId, email, role) }

    override suspend fun invites(orgId: String): Result<List<OrgInvite>> =
        runCatching { client.invites(orgId) }
}
